/**
 * @generated SignedSource<<1d8e10623efc33e9fa7c5b842ceec307>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassesAllGradesQuery$variables = Record<PropertyKey, never>;
export type ClassesAllGradesQuery$data = {
  readonly allGradeLevels: ReadonlyArray<{
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
    readonly order: number;
  }>;
};
export type ClassesAllGradesQuery = {
  response: ClassesAllGradesQuery$data;
  variables: ClassesAllGradesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GradeLevelNode",
    "kind": "LinkedField",
    "name": "allGradeLevels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "order",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesAllGradesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClassesAllGradesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bce52c0c239b98f94d7a47072c06a000",
    "id": null,
    "metadata": {},
    "name": "ClassesAllGradesQuery",
    "operationKind": "query",
    "text": "query ClassesAllGradesQuery {\n  allGradeLevels {\n    id\n    name\n    isActive\n    order\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e88da653927b98eabf19205a9d5369d";

export default node;
